import React from "react";
import { TrendingUp, BookOpen, Map, Users, ChartBar, Lightbulb, MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const services = [{
  title: "uPVC Fascias & Soffits",
  icon: TrendingUp
}, {
  title: "Dry Verge Systems",
  icon: BookOpen
}, {
  title: "Dry Ridge Installation",
  icon: Map
}, {
  title: "EPDM Rubber Roofing",
  icon: Users
}, {
  title: "Full Roof Replacements",
  icon: ChartBar
}, {
  title: "Guttering & Drainage",
  icon: Lightbulb
}];
export default function CoreServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="3958" id="service-details" className="bg-background py-16 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          {}
          <div ref={ref} className={cn("lg:col-span-6 flex flex-col gap-8 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
            <h2 className="font-serif text-4xl md:text-[42px] leading-tight text-foreground font-bold">
              Premium Roofing Solutions
            </h2>

            <ul className="flex flex-col gap-4">
              {services.map((service, i) => <li key={i} data-index={i} className="flex items-center gap-4 group p-4 bg-secondary rounded-lg border border-white/10 shadow-sm hover:shadow-[inset_0_0_15px_rgba(234,179,8,0.2)] transition-all duration-300 cursor-pointer">
                  <div className="shrink-0">
                    <service.icon className="w-6 h-6 text-primary" strokeWidth={2} />
                  </div>
                  <span className="font-sans text-lg font-medium text-secondary-foreground group-hover:text-primary transition-colors duration-300">
                    {service.title}
                  </span>
                </li>)}
            </ul>

            <div className="pt-4">
              <Link to="/AreasWeCoverPage">
                
              </Link>
            </div>
          </div>

          {}
          <div className={cn("lg:col-span-6 w-full h-full flex items-center justify-center lg:justify-end transition-all duration-700 delay-200 ease-out", isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8")}>
            <div className="relative w-full max-w-xl overflow-hidden rounded-xl shadow-xl bg-muted/10">
              <img src="https://fivestarsroofline.com/wp-content/uploads/2026/03/639450685_1508805101245920_194738150268176335_n.jpg" data-wvc-srcset="https://fivestarsroofline.com/wp-content/uploads/2026/03/639450685_1508805101245920_194738150268176335_n.jpg-wvc-srcset" data-wvc-sizes="https://fivestarsroofline.com/wp-content/uploads/2026/03/639450685_1508805101245920_194738150268176335_n.jpg-wvc-sizes" alt="High-resolution roofing installation detail" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-700 ease-out" loading="lazy" />
              {}
              <div className="absolute inset-0 ring-1 ring-black/5 rounded-xl pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}